import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for CTA Section - fade in with scale and bounce
 */
export const animateCTASection = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const headingBox = element.querySelector('[class*="HeadingBox"]') || element.querySelector('[class*="wrapper"]');
    const content = element.querySelector('[class*="ctaContent"]') || element;
    
    // Set initial state immediately to prevent flash
    if (headingBox) {
      gsap.set(headingBox, { opacity: 0, y: -30 });
    }
    if (content) {
      gsap.set(content, { opacity: 0, scale: 0.9 });
    }
    
    const timer = setTimeout(() => {
      if (headingBox) {
        gsap.to(headingBox, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        });
      }
      
      if (content) {
        gsap.to(content, {
          opacity: 1,
          scale: 1,
          duration: 1.2,
          delay: 0.2,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        });
      }
      
      ScrollTrigger.refresh();
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

